// "Translations" under a check's English name (Settings → QC lists, trims): optional wording in each other screen
// language (Arabic, Chinese…), collapsed by default. The inspector sees their language when it is filled in, otherwise
// the English name; the office always sees the English name.
import { esc } from "./lib.js";
import { KEYED_LANGS, LANGS, LANG_ENGLISH_NAME } from "../../shared/i18n/index.js";

/** Arabic and Chinese: the languages with their own QC inspection wording (kept compact; the others show the English name). */
const trLangs = () => KEYED_LANGS.map((c) => LANGS.find((l) => l.code === c)!);

/** Form version: inputs named `${prefix}_${lang}` (the trim form). */
export function trTranslationsHtml(tr: Record<string, string> | undefined, ro: string, prefix: string): string {
  const others = trLangs();
  const filled = others.filter((l) => tr?.[l.code]).length;
  return `<details class="tr-boxes"><summary>Translations${filled ? ` (${filled})` : ""} <span class="muted">for QC inspectors</span></summary>
${others.map((l) => `<label class="tr-box"><span>${esc(LANG_ENGLISH_NAME[l.code] || l.code)} wording</span><input name="${prefix}_${l.code}" lang="${l.code}" dir="${l.dir}" maxlength="120" value="${esc(tr?.[l.code] || "")}" ${ro}></label>`).join("")}</details>`;
}
/** List-row version (Settings → QC): inputs with data attributes for the row. */
export function trRowHtml(tr: Record<string, string> | undefined, attrs: string, open: boolean): string {
  const others = trLangs();
  const filled = others.filter((l) => tr?.[l.code]).length;
  return `<details class="tr-boxes" ${open ? "open" : ""} ${attrs}><summary>Translations${filled ? ` (${filled})` : ""}</summary>
${others.map((l) => `<label class="tr-box"><span>${esc(LANG_ENGLISH_NAME[l.code] || l.code)} wording</span><input data-qcl-tr="${l.code}" ${attrs} lang="${l.code}" dir="${l.dir}" maxlength="120" value="${esc(tr?.[l.code] || "")}"></label>`).join("")}</details>`;
}
